import React, { Component, Fragment } from 'react';
import {connect} from "react-redux";
import {IRootState} from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import ApiService from "../../ApiService";
import {BulkCreateSiteFormWithFormCount} from "../../../models/BulkCreateSiteForm";
import Table, {TableColumn} from "../../Table";
import SchoolCell from "../../SchoolCell";
import {TableRowProps} from "../../TableRow";
import {Link} from "react-router-dom";
import {CommandBarButton} from "office-ui-fabric-react";
import School from "../../../models/School";
import TableCell from '../../TableCell';
import SchoolPageTitle from '../../SchoolPageTitle';
import AdminSchoolMenu from '../../AdminSchoolMenu';

interface SchoolBulkSiteFormsPageProps {
    tenantId: string;
    schoolCode: string;
    
    apiService: ApiService;
}

interface SchoolBulkSiteFormsPageState {
    school?: School;
    forms: BulkCreateSiteFormWithFormCount[];
}

class SchoolBulkSiteFormsPage extends Component<SchoolBulkSiteFormsPageProps & DispatchProps ,SchoolBulkSiteFormsPageState> {
    static displayName = SchoolBulkSiteFormsPage.name;

    private static columns: TableColumn[] = [
        {
            title: "School",
            propertyPath: "school",
            flex: 1,
        },
        {
            title: "Number Of Sites",
            propertyPath: "details",
            flex: 2,
            extraDetail: "Id"
        },
        {
            title: "Last Updated",
            propertyPath: "bulkCreateSiteForm.updatedAt",
            flex:1,
            type: "date",
            enableSort: true
        },
        {
            title: "Approved",
            propertyPath: "bulkCreateSiteForm.locked",
            flex: 1,
            enableSort: true
        },
        {
            title: "Updated By",
            propertyPath: "Updated By",
            flex: 2,
            enableSort: false
        },
    ];

    constructor(props: SchoolBulkSiteFormsPageProps & DispatchProps) {
        super(props);
        
        this.state = {
            school: undefined,
            forms: []           
        };
    }
    
    private cellForColumn = (item: BulkCreateSiteFormWithFormCount,column: TableColumn,index: number) => {

        if(column.propertyPath === "school")
        {
            return <SchoolCell key={index} schoolKey={item.bulkCreateSiteForm} school={this.state.school} flex={column.flex}/>
        }

        if (column.propertyPath === "Updated By") {
            return <TableCell flex={column.flex}>
                <Fragment>
                    <span>{item.bulkCreateSiteForm.updatedByDisplayName}</span>
                    <span className="cdb-table__extra-detail">{item.bulkCreateSiteForm.updatedByUPN}</span>
                </Fragment>
            </TableCell>
        }
        
        if (column.propertyPath === "details") {
            return <TableCell flex={column.flex}>
                <Fragment>
                    <span>{item.formCount}</span>
                    <span className="cdb-table__extra-detail">{`${item.bulkCreateSiteForm.id}`}</span>
                </Fragment>
            </TableCell>
        }
    }
    
    private rowPropsForItem = (item: BulkCreateSiteFormWithFormCount): TableRowProps => {
        
        return {
            to: `/cdb-admin/schools/${this.props.tenantId}/${this.props.schoolCode}/bulk-site-forms/${item.bulkCreateSiteForm.id}`,
            enableRowLink: true,
        };
    }
    

    async componentDidMount() {
        
        if(this.props.tenantId && this.props.schoolCode)
        {
            const school = await this.props.apiService.getSchoolAdmin(this.props.tenantId,this.props.schoolCode);
            const forms = await this.props.apiService.getBulkCreateSiteForms(this.props.tenantId, this.props.schoolCode);

            this.setState({
                school,
                forms
            });
        }
        
    }

    async componentDidUpdate(prevProps: Readonly<SchoolBulkSiteFormsPageProps & DispatchProps>, prevState: any): Promise<void> {
        
        if(this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode)
        {
            const school = await this.props.apiService.getSchoolAdmin(this.props.tenantId,this.props.schoolCode);
            const forms = await this.props.apiService.getBulkCreateSiteForms(this.props.tenantId, this.props.schoolCode);

            this.setState({
                school,
                forms
            });
        }
    }

    render () {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Site Creation" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                <Table
                    title={"Bulk Site Forms"}
                    columns={SchoolBulkSiteFormsPage.columns}
                    items={this.state.forms}
                    enableSort={true}
                    cellForColumn={this.cellForColumn}
                    rowPropsForItem={this.rowPropsForItem}>
                    <Link to={`/cdb-admin/schools/${this.props.tenantId}/${this.props.schoolCode}/bulk-site-forms/`}>
                        <CommandBarButton
                            iconProps={{iconName: "Add"}}
                            text="Add"
                            onClick={() => {}}
                        />
                    </Link>
                </Table>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: {match: any}): SchoolBulkSiteFormsPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;
        
        return {
            tenantId,
            schoolCode,
            apiService: state.auth.apiService
        };
    }
)(SchoolBulkSiteFormsPage)